import { get } from 'lodash';
import * as React from 'react';
import { useFormikContext } from 'formik';
import TextField, { type TextFieldProps } from '@mui/material/TextField';
import useIsMobile from '../../utils/useIsMobile';
import { useDisabled } from './providers/DisableProvider';
import useGutterBottom from './utils/useGutterBottom';

export type TextInputProps = TextFieldProps & {
  name: string;
  select?: never;
  errorGutterBottom?: boolean;
};

const TextInput = ({ name, errorGutterBottom, ...props }: TextInputProps) => {
  const { setFieldValue, setFieldTouched, values, errors, touched } =
    useFormikContext<any>();
  const isError = !!(get(touched, name) && get(errors, name));
  const isMobile = useIsMobile();
  const { getDisabled } = useDisabled();
  const gutterSize = useGutterBottom();

  return (
    <TextField
      variant="outlined"
      error={!!(get(touched, name) && get(errors, name))}
      sx={{
        paddingBottom: errorGutterBottom ? (isError ? 0 : gutterSize) : 0,
        ...props.sx,
      }}
      size={isMobile ? 'small' : 'medium'}
      disabled={getDisabled?.(name)}
      {...props}
      helperText={
        isError ? (get(errors, name) as string) : props.helperText || ''
      }
      value={get(values, name) || ''}
      onChange={(event) => {
        props.onChange?.(event);
        setFieldValue(name, event.target.value);
      }}
      onBlur={(event) => {
        props.onBlur?.(event);
        setFieldTouched(name, true);
      }}
    />
  );
};

export default TextInput;
